import { render, staticRenderFns } from "./CredentialsNew.vue?vue&type=template&id=a6c7aaf4&scoped=true&"
import script from "./CredentialsNew.vue?vue&type=script&lang=js&"
export * from "./CredentialsNew.vue?vue&type=script&lang=js&"
import style0 from "./CredentialsNew.vue?vue&type=style&index=0&id=a6c7aaf4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c7aaf4",
  null
  
)

export default component.exports